import aesReduxConstants from '../constants';

export var notificationsReducer = function() {
  const __defaultNotificationsState = {
    notifications: [],
    currentPage: 0,
    unreadCount: 0,
    limit: 10,
    loading: true,
  };

  const reducer = function(state, action) {
    const __constants = aesReduxConstants;

    if (state === undefined) state = __defaultNotificationsState;

    let delta = {};
    switch (action.type) {
      case __constants.SET_ALL_AS_READ:
        var notifications = [];
        for (var i = 0; i < state.notifications.length; i++) {
          var notification = state.notifications[i];
          if (notification.readAt === null) {
            notification.readAt = action.timestamp;
          }
          notifications.push(notification);
        }
        delta = { loading: false, notifications, unreadCount: 0 };
        break;

      case __constants.GET_NOTIFICATIONS:
        delta = { loading: true };
        break;
      case __constants.GET_NOTIFICATIONS_SUCCESS:
        delta = {
          loading: false, notifications: state.notifications.concat(action.notifications), currentPage: state.currentPage + 1, unreadCount: action.unreadCount,
        };
        break;

      case __constants.APPEND_NOTIFICATION:
        delta = { loading: false, notifications: state.notifications.concat(action.notification), unreadCount: state.unreadCount + 1 };
        break;

      case __constants.REPLACE_NOTIFICATION:
        var notifications = [];
        for (var i = 0; i < state.notifications.length; i++) {
          var notification = state.notifications[i];
          if (notification.id == action.notification.id) {
            notifications.push(action.notification);
          } else {
            notifications.push(notification);
          }
        }
        delta = { loading: false, notifications };
        break;

      default:
        return state;
    }

    return Object.assign({}, state, delta);
  };

  return reducer;
};

export default notificationsReducer();
